/**
 * Compra el Look - Carousel
 * 3 slides visible desktop, 1 mobile. Dots dinámicos.
 */
function initLopShopTheLookCarousel(trackEl) {
  if (!trackEl || typeof Flickity === 'undefined') return;

  const wrapper = trackEl.closest('.lop-shop-the-look-carousel__wrapper');
  const dotsContainer = wrapper ? wrapper.querySelector('.lop-shop-the-look-carousel__dots') : null;
  const slides = trackEl.querySelectorAll('.carousel__slide');
  let flkty = null;

  function getVisibleCount() {
    return window.innerWidth >= 768 ? 3 : 1;
  }

  var GAP_PX = 8;

  function updateVisibleSlideGaps(flktyInst) {
    if (!flktyInst || !flktyInst.cells || !flktyInst.cells.length) return;
    var visibleCount = getVisibleCount();
    var lastVisibleIndex = Math.min(flktyInst.selectedIndex + visibleCount - 1, flktyInst.cells.length - 1);
    var useGap = window.innerWidth >= 768;
    flktyInst.cells.forEach(function (cell, i) {
      if (cell && cell.element) {
        var isLast = i === lastVisibleIndex;
        cell.element.classList.toggle('is-last-visible', isLast);
        if (useGap) {
          cell.element.style.marginRight = isLast ? '0' : GAP_PX + 'px';
        } else {
          cell.element.style.marginRight = '';
        }
      }
    });
    if (useGap && typeof flktyInst.positionCells === 'function') {
      flktyInst.positionCells();
    }
  }

  function getPageCount() {
    return Math.max(1, slides.length - getVisibleCount() + 1);
  }

  function updateHotspotCardPosition(hotspot) {
    if (typeof lopStlUpdateHotspotCardPosition === 'function') {
      lopStlUpdateHotspotCardPosition(hotspot, '.lop-shop-the-look-carousel__figure');
    }
  }

  function updateAllVisibleHotspotPositions() {
    if (!wrapper) return;
    var hotspots = wrapper.querySelectorAll('.lop-hotspot');
    for (var i = 0; i < hotspots.length; i++) updateHotspotCardPosition(hotspots[i]);
  }

  function createDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    const pageCount = getPageCount();
    for (let i = 0; i < pageCount; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'lop-stl-carousel-dot';
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    }
  }

  function updateDots() {
    if (!flkty) return;
    const selected = flkty.selectedIndex;
    const pageCount = getPageCount();
    const selectedDotIndex = Math.min(selected, pageCount - 1);
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.lop-stl-carousel-dot') : [];
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-selected', i === selectedDotIndex);
    });
    updateVisibleSlideGaps(flkty);
  }

  function initFlickity() {
    if (flkty) {
      flkty.destroy();
      flkty = null;
    }

    createDots();

    if (wrapper) {
      if (window.innerWidth >= 768) {
        wrapper.style.setProperty('--carousel-visible-width', wrapper.offsetWidth + 'px');
      } else {
        wrapper.style.width = '';
        wrapper.style.marginLeft = '';
        wrapper.style.setProperty('--carousel-visible-width', wrapper.offsetWidth + 'px');
      }
    }

    flkty = new Flickity(trackEl, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      groupCells: 1,
      cellSelector: '.carousel__slide',
      resize: true
    });

    requestAnimationFrame(function () {
      var wrap = trackEl.closest('.lop-shop-the-look-carousel__wrapper');
      var viewportEl = trackEl.querySelector('.flickity-viewport');
      if (wrap) {
        var w = wrap.offsetWidth;
        wrap.style.setProperty('--carousel-visible-width', w + 'px');
        if (viewportEl) {
          viewportEl.style.maxWidth = w + 'px';
          viewportEl.style.width = w + 'px';
        }
        if (flkty && flkty.resize) flkty.resize();
        updateVisibleSlideGaps(flkty);
        trackEl.classList.add('lop-carousel-ready');
        updateAllVisibleHotspotPositions();
      }
    });

    function updateNav() {
      var prevBtn = wrapper ? wrapper.querySelector('.lop-shop-the-look-carousel__nav-btn--prev') : null;
      var nextBtn = wrapper ? wrapper.querySelector('.lop-shop-the-look-carousel__nav-btn--next') : null;
      if (prevBtn) prevBtn.disabled = flkty.selectedIndex === 0;
      if (nextBtn) nextBtn.disabled = flkty.selectedIndex >= getPageCount() - 1;
    }

    flkty.on('select', function () {
      updateDots();
      updateNav();
      var openOrHover = wrapper ? wrapper.querySelectorAll('.lop-hotspot.is-open, .lop-hotspot:hover') : [];
      for (var i = 0; i < openOrHover.length; i++) updateHotspotCardPosition(openOrHover[i]);
      updateAllVisibleHotspotPositions();
    });
    flkty.on('staticClick', function (event) {
      var openBtn = event.target && event.target.closest && event.target.closest('.lop-stl-open-main');
      if (openBtn && window.lopStlOpenFromButton && window.lopStlOpenFromButton(openBtn)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    flkty.on('settle', function () {
      updateVisibleSlideGaps(flkty);
    });
    updateDots();
    updateNav();

    if (dotsContainer) {
      dotsContainer.addEventListener('click', function (e) {
        var dot = e.target.closest('.lop-stl-carousel-dot');
        if (dot && flkty) flkty.select(parseInt(dot.dataset.index, 10));
      });
    }

    var prevBtn = wrapper ? wrapper.querySelector('.lop-shop-the-look-carousel__nav-btn--prev') : null;
    var nextBtn = wrapper ? wrapper.querySelector('.lop-shop-the-look-carousel__nav-btn--next') : null;
    if (prevBtn) prevBtn.addEventListener('click', function () { flkty.previous(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { flkty.next(); });

    /* Hotspot: click on pin = no navigate; on mobile toggle card. Click on card = navigate. */
    if (wrapper) {
      wrapper.addEventListener('click', function (e) {
        var hotspot = e.target.closest('.lop-hotspot');
        if (!hotspot) return;
        if (e.target.closest('.lop-hotspot__card')) return;
        e.preventDefault();
        if (window.innerWidth >= 768) return;
        hotspot.classList.toggle('is-open');
        var all = wrapper.querySelectorAll('.lop-hotspot');
        for (var i = 0; i < all.length; i++) {
          if (all[i] !== hotspot) all[i].classList.remove('is-open');
        }
        if (hotspot.classList.contains('is-open')) updateHotspotCardPosition(hotspot);
      });
    }

    if (wrapper) {
      wrapper.addEventListener('mouseover', function (e) {
        var hotspot = e.target.closest('.lop-hotspot');
        if (!hotspot) return;
        var rel = e.relatedTarget;
        if (rel && hotspot.contains(rel)) return;
        updateHotspotCardPosition(hotspot);
      });
    }
  }

  /* Mobile: close hotspot cards when tapping outside */
  if (wrapper) {
    document.addEventListener('click', function (e) {
      if (window.innerWidth >= 768) return;
      if (!wrapper.contains(e.target)) return;
      if (e.target.closest('.lop-hotspot')) return;
      var hotspots = wrapper.querySelectorAll('.lop-hotspot');
      for (var i = 0; i < hotspots.length; i++) hotspots[i].classList.remove('is-open');
    });
  }

  function updateCarouselWidth() {
    if (!wrapper || !flkty) return;
    var w = wrapper.offsetWidth;
    if (window.innerWidth < 768) {
      wrapper.style.width = '';
      wrapper.style.marginLeft = '';
    }
    wrapper.style.setProperty('--carousel-visible-width', w + 'px');
    var vp = trackEl.querySelector('.flickity-viewport');
    if (vp) {
      vp.style.maxWidth = w + 'px';
      vp.style.width = w + 'px';
    }
    if (flkty.resize) flkty.resize();
    updateVisibleSlideGaps(flkty);
    if (dotsContainer && dotsContainer.children.length !== getPageCount()) {
      createDots();
      updateDots();
    }
  }

  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      updateCarouselWidth();
      if (wrapper) {
        var hotspots = wrapper.querySelectorAll('.lop-hotspot.is-open, .lop-hotspot:hover');
        for (var i = 0; i < hotspots.length; i++) updateHotspotCardPosition(hotspots[i]);
      }
    }, 150);
  });

  initFlickity();
}
